import { useRef } from 'react';
import { isEqual } from 'lodash';

export const useDeepCompareMemoize = <T>(value: T) => {
    const ref = useRef<T>(value);

    if (!isEqual(value, ref.current)) {
        ref.current = value;
    }

    return ref.current;
};
